import BaseInteractionService from '@configuratorware/configurator-frontendgui/App/Services/InteractionService';
import { getConf, SaveTypes } from '@configuratorware/configurator-frontendgui/App/configuration';
import { getConfiguration } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Selectors';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import Api from '@configuratorware/configurator-frontendgui/Framework/Api';
import { acquireIdToken } from '../authConfig';

class InteractionService extends BaseInteractionService {
  async downloadPdfAndCreateBlobURL() {
    const { ui, configurator } = Services;
    ui.show('globalLoader');
    try {
      await configurator.captureAndSaveConfiguration(SaveTypes.PRINT);
    } finally {
      ui.hide('globalLoader');
    }

    const params = { ...Api.getGETParameters() };
    const customQueryParams = {};
    const documentType = 'user';
    const customKeys = Object.keys(customQueryParams);
    const keys = ['_language', '_client', '_channel', '_display_net_prices', '_share_url'];
    const mergedKeys = keys.concat(customKeys);
    const query = new URLSearchParams(location.search);
    let queryString = Object.keys(params)
      .filter((key) => mergedKeys.indexOf(key) !== -1)
      .map((key) =>
        key === '_share_url' ? key + '=' + encodeURIComponent(params[key]) : key + '=' + params[key]
      )
      .join('&');
    if (query.has('_hide_prices')) {
      queryString = queryString.concat('&_hide_prices=' + query.get('_hide_prices'));
    }
    if (query.has('_cta_element')) {
      queryString = queryString.concat('&_cta_element=' + query.get('_cta_element'));
    }
    const configuration = getConfiguration(configurator.state);
    const documentUrl = `${getConf('network.baseURL', '/')}configurations/pdf/${documentType}/${
      configuration.code
    }?${queryString}`;

    const result = await this.downloadDocument(documentUrl);
    this.blobURL = result?.url || '';
    this.blobFilename = result?.filename || `offer_${configuration.code}.docx`;
  }

  async downloadDocument(documentUrl) {
    const authToken = await acquireIdToken();
    if (!authToken) {
      throw new Error('Login required for downloading the document!');
    }
    const { ui } = Services;
    ui.show('globalLoader');
    let headers = new Headers();
    headers.append('Authorization', authToken);
    try {
      const response = await fetch(documentUrl, { headers });
      if (!response.ok) {
        response.text().then((text) => {
          throw new Error(text);
        });
      } else {
        const disposition = response.headers.get('content-disposition') || '';
        const filename = disposition.match(/filename=["']?([^"';\s]+)/)?.[1] || null;
        const blob = await response.blob();
        return { url: window.URL.createObjectURL(blob), filename };
      }
    } catch (e) {
      console.error('Error occurred while creating temporary object URL from document', e);
    } finally {
      ui.hide('globalLoader');
    }
  }

  createPdfUrl() {
    return this.blobURL || '';
  }

  getPdfFilename() {
    return this.blobFilename || '';
  }
}

export default InteractionService;
